import type { FieldValue } from '~/types';

export const toField = (value?: string | null): FieldValue => ({
  value: value ?? undefined,
  isValid: undefined
});
